import { useState, useEffect } from 'react';

// graphql
import { useAuditorsQuery, PageInfo } from '@/generated/graphql';

// material ui
import { Box, Button, Grid } from '@mui/material';

// interfaces
import { IAuditor, IAuditorQueryVariable, mapGQLAuditor, IAuditorTable } from '@/shared/interfaces';

// css
import './auditor-style.css';

// components
import { TableAuditors } from './components/table.auditors';
import { AddAuditor } from './components/add-auditor';
import { EditAuditor } from './components/edit.auditor';
import { ChangePasswordAuditor } from './components/edit-auditor-password';

export const AuditorsPage = () => {
  const [auditors, setAuditors] = useState<IAuditorTable[]>([]);
  const [auditorsQueryVariable, setAuditorsQueryVariable] = useState<IAuditorQueryVariable>({
    first: 25,
  });

  const [pageInfo, setPageInfo] = useState<PageInfo>();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [getAuditorLoading, setGetAuditorLoading] = useState<boolean>(false);
  const [addOpen, setAddOpen] = useState(false);

  // edit auditor
  const [editOpen, setEditOpen] = useState(false);
  const [disableOpen, setDisableOpen] = useState(false);
  const [updatePasswordOpen, setUpdatePasswordOpen] = useState(false);
  const [editAuditorData, setEditAuditorData] = useState<IAuditorTable>();

  // QUERIES
  const auditorQuery = useAuditorsQuery({
    notifyOnNetworkStatusChange: true,
    variables: auditorsQueryVariable,
    onCompleted(data) {
      const mapAuditors: IAuditor[] = data.auditors.nodes.map((auditor) => mapGQLAuditor(auditor));

      setTimeout(() => {
        setAuditors(
          mapAuditors.map((auditor) => ({
            id: auditor.id,
            name: `${auditor.firstName} ${auditor.lastName}`,
            firstName: auditor.firstName,
            lastName: auditor.lastName,
            username: auditor.user.username,
            createdAt: auditor.createdAt,
            contactNumber: auditor.contactNumber,
          })),
        );
        setPageInfo(data.auditors.pageInfo);
        setTotalCount(data.auditors.totalCount);
      }, 100);
    },
  });

  // END QUERIES

  const auditorEvent = (data: IAuditorTable, eventName: string) => {
    console.log('🚀 ~ file: auditors.page.tsx:124 ~ auditorEvent ~ eventName:', eventName);
    if (eventName == 'edit') {
      setEditAuditorData(data);
      setEditOpen(true);
    } else if (eventName == 'update password') {
      setEditAuditorData(data);
      setUpdatePasswordOpen(true);
    } else if (eventName == 'disable') {
      setEditAuditorData(data);
      setDisableOpen(true);
    }
  };

  const refetchData = () => {
    auditorQuery.refetch({
      ...auditorsQueryVariable,
    });
  };

  useEffect(() => {
    setGetAuditorLoading(auditorQuery.loading);
  }, [auditorQuery.loading]);

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#C5D8EC',
          height: '100%',
        }}
        p={2}>
        <Grid justifyContent={'end'} display={'flex'}>
          <Button variant="contained" onClick={() => setAddOpen(true)}>
            Add Auditor
          </Button>
        </Grid>
        <TableAuditors
          rows={auditors}
          setAuditorQueryVariable={setAuditorsQueryVariable}
          auditorQueryVariable={auditorsQueryVariable}
          totalCount={totalCount}
          pageInfo={pageInfo}
          auditorEvent={auditorEvent}
          getAuditorLoading={getAuditorLoading}
        />
      </Box>
      <AddAuditor open={addOpen} setOpen={setAddOpen} refetchData={refetchData} />
      <EditAuditor open={editOpen} setOpen={setEditOpen} refetchData={refetchData} auditor={editAuditorData} />
      <ChangePasswordAuditor
        isOpen={updatePasswordOpen}
        openEvent={setUpdatePasswordOpen}
        refetchData={refetchData}
        datas={editAuditorData}
      />
    </>
  );
};
